
import React from 'react';
import { sprintf } from "sprintf-js";

class ImgTint extends React.Component {

  render = () => {
    const { img, tint } = this.props;
    const color = sprintf("rgba(%d, %d, %d, %f)", tint.r, tint.g, tint.b, tint.a);

    const overlayStyle = {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: "0",
      left: "0",
      backgroundColor: color,
      zIndex: "-1",
    };

    const container_style = {
        display: "contents",
        height: "inherit",
        zIndex: "-1",
    };

    const img_style = {
      width: "100%",
      objectFit: "cover",
    }

    return (
      <div style={container_style}>
        <img className="banner-img" src={img} alt={'Banner'} style={img_style}/>
        <div style={overlayStyle}/>
      </div>
    )
  }
}

export { ImgTint };
